import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACIgnoreIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 5.5C6.05964 5.5 5.5 6.05964 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H17.2502C17.9406 18.5 18.5002 17.9404 18.5002 17.25V6.75C18.5002 6.05964 17.9406 5.5 17.2502 5.5H6.75ZM4 6.75C4 5.23122 5.23122 4 6.75 4H17.2502C18.769 4 20.0002 5.23122 20.0002 6.75V17.25C20.0002 18.7688 18.769 20 17.2502 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75ZM9.21967 9.21967C9.51256 8.92678 9.98744 8.92678 10.2803 9.21967L12 10.9393L13.7197 9.21967C14.0126 8.92678 14.4874 8.92678 14.7803 9.21967C15.0732 9.51256 15.0732 9.98744 14.7803 10.2803L13.0607 12L14.7803 13.7197C15.0732 14.0126 15.0732 14.4874 14.7803 14.7803C14.4874 15.0732 14.0126 15.0732 13.7197 14.7803L12 13.0607L10.2803 14.7803C9.98744 15.0732 9.51256 15.0732 9.21967 14.7803C8.92678 14.4874 8.92678 14.0126 9.21967 13.7197L10.9393 12L9.21967 10.2803C8.92678 9.98744 8.92678 9.51256 9.21967 9.21967Z"
        fill="currentColor"
      />
    </svg>
  );
};
